var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5469 15.9015C76.7807 29.1353 83.8601 58.7602 70.6263 71.994C57.3925 85.2279 28.3119 81.9603 15.0781 68.7265C1.84422 55.4927 18.8978 34.7522 32.1316 21.5184C45.3655 8.28454 50.3131 2.66767 63.5469 15.9015Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7777 60.7408C58.1201 54.2275 55.073 42.0365 53.7741 36.1457C53.4601 34.722 52.7731 31.678 52.7076 31.1594C52.3713 28.4944 36.4411 32.8022 28.2804 34.2951C30.4597 44.584 35.0469 65.4161 35.9614 66.4329C36.8759 67.4497 49.1628 64.3072 55.192 62.6089",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7501 41.6132C33.6348 41.0911 33.6809 39.9497 34.7867 39.5615C36.169 39.0762 36.9493 40.1486 37.0275 40.2904C37.1058 40.4322 37.7451 41.9753 36.1797 42.7696",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1542 51.5898C36.6197 51.5765 35.5227 51.2581 35.4111 50.0914C35.2715 48.633 36.4996 48.1327 36.656 48.0908C36.8125 48.0488 39.5055 48.0908 38.7536 50.4155",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6466 38.9331C43.7654 38.487 48.4715 37.4611 50.345 36.9258M41.312 42.2787C42.4272 41.9441 45.1259 41.2081 46.9995 40.9404M41.312 47.297C41.6466 47.297 51.6832 45.9588 52.6869 44.9551M42.6502 50.308C43.3193 50.308 47.334 48.6352 46.6649 49.3043",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58.5011C40.2376 58.9904 41.4366 59.4535 42.5972 60.1122C42.8717 60.268 44 61.1749 44 60.39C44 60.0798 43.67 57.0911 44 57.7511",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.9b313a3175512d2aa0302727ff2a7abd.svg";
export { ForwardRef as ReactComponent };